export default "__VITE_ASSET__072b904b__"